import { Button } from 'components/button/Button'
import {
  SStoryButtonContainer,
  SStoryHeader,
  SStoryParagraph,
  SStorySection,
  SStorySignatureWrapper,
  SStorySmallHeader,
} from 'components/content/about/aboutTeam/styled'
import { Picture } from 'components/picture/Picture'
import { BlockSpinner } from 'components/spinner/Spinner'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'

export function FullStoryContent(props: { closeModal: () => void }) {
  const { t, isLoading } = useDynamicTranslations('security')
  if (isLoading) return <BlockSpinner />
  return (
    <>
      <SStorySmallHeader variant="h7" as="h5">
        {t('security.story.header')}
      </SStorySmallHeader>

      <SStoryHeader variant="h5" as="h5">
        {t('security.story.header_2')}
      </SStoryHeader>

      <SStorySection>
        <SStoryParagraph variant="body">{t('security.story.paragraph_1')}</SStoryParagraph>

        <Picture imageKey={'illustrations/what'} alt="Illustration" width="188px" />
      </SStorySection>

      <SStoryParagraph>{t('security.story.paragraph_2')}</SStoryParagraph>

      <SStoryParagraph>{t('security.story.paragraph_3')}</SStoryParagraph>

      <SStorySection>
        <Picture imageKey={'illustrations/testament'} alt="Another illustration" width="170px" />
        <SStoryParagraph>{t('security.story.paragraph_4')}</SStoryParagraph>
      </SStorySection>

      <SStoryParagraph>{t('security.story.paragraph_5')}</SStoryParagraph>

      <SStoryParagraph>{t('security.story.paragraph_6')}</SStoryParagraph>

      <SStoryParagraph>{t('security.story.paragraph_7')}</SStoryParagraph>

      <SStoryParagraph>{t('security.story.paragraph_8')}</SStoryParagraph>

      <SStorySignatureWrapper>
        <img src="/images/signature.svg" alt="CEO signature" />
      </SStorySignatureWrapper>

      <SStoryParagraph>{t('security.story.paragraph_9')}</SStoryParagraph>

      <SStoryButtonContainer>
        <Button type="button" size="large" variant="secondary" onClick={props.closeModal}>
          {t('security.story.close_button')}
        </Button>

        <Button type="button" href={'/articles'} size="large">
          {t('security.story.articles_link_button')}
        </Button>
      </SStoryButtonContainer>
    </>
  )
}
